// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1RyN1","actionsCol":"EnrolledClinics_actionsCol__2aShf"};